const callback = (mutationsList) => {
    for (const mutation of mutationsList) {

        if (mutation.type === "childList") {
            const IMG = mutation.target.querySelector(".ctct-form-footer-img");
            const TXT = mutation.target.querySelector("#g-recaptcha-response");

            if (IMG) {
                IMG.setAttribute("alt", "Constant Contact");
            }

            if (TXT) {
                TXT.setAttribute("aria-hidden", "true");
                TXT.setAttribute("aria-label", "This field is used to protect our website from bots. If you're a human reading this, please do not modify this field.");
                TXT.setAttribute("aria-readonly", "true");
            }
        }
    }
};

const observer = new MutationObserver(callback);

observer.observe(document.querySelector(".ctct-inline-form"), {
    attributes: true,
    childList:  true,
    subtree:    true,
});
